import camelCase from 'lodash/camelCase';
export const generateGruserObjectId = ({ gruserId, gruserTypeid, gruserItemid })=>{
    return `${gruserId}-${gruserTypeid}-${gruserItemid || 'null'}`;
};
export const getModuleDataFromPapiModule = (module)=>{
    const { moduleData } = module;
    const { dataKey = '' } = moduleData;
    return moduleData[camelCase(dataKey)] || {};
};
export const isModuleResponse = (response)=>response && response.hasOwnProperty('id') && response.hasOwnProperty('version') && response.hasOwnProperty('moduleData');

//# sourceMappingURL=helpers.js.map